module.exports = __webpack_public_path__ + "static/media/Crafted_with.4121aad2.svg";